<template>
  <form
    v-on:submit.prevent="$route.name == 'ficha' ? false : saveForm()"
    novalidate
  >
    <LoaderContent v-if="isLoading" :welcomeMessage="false" />

    <div class="form-row">
      <InputAvatar
        v-if="$route.name == 'ficha'"
        class="input-avatar-container"
      />

      <div
        class="form-group col-12 col-sm-6 col-md-4 pronoun-container mb-4"
        :class="{ 'is-invalid': $v.pronoun.$error }"
      >
        <div>
          <label :for="'personal-input-pronoun' + _uid"
            ><span>*</span>¿Pronombre adecuado para vos?</label
          >
          <span
            class="btn btn-sm p-0 align-middle ml-1"
            @click="showModalDiversityInput()"
            ><icon-help-circle-outline class="text-muted"
          /></span>
        </div>

        <selectize
          :id="'personal-input-pronoun' + _uid"
          :settings="pronounSettings"
          v-model="pronoun"
        >
          <option
            :value="pronoun.id"
            v-for="(pronoun, index) in $store.state.domains.pronouns"
            :key="index"
          >
            {{ pronoun.id == "she_her" ? "Ella" : "" }}
            {{ pronoun.id == "he_his" ? "Él" : "" }}
            {{ pronoun.id == "him_his" ? "Él" : "" }}
            {{ pronoun.id == "other" ? "Otro" : "" }}
            {{ pronoun.id == "no_reply" ? "No quiero contestar" : "" }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 firstname-container mb-4"
        :class="{ 'is-invalid': $v.firstname.$error }"
      >
        <div>
          <label :for="'personal-input-first-name' + _uid"
            ><span>*</span> Nombre</label
          >
        </div>

        <input
          type="text"
          class="form-control"
          :id="'personal-input-first-name' + _uid"
          v-model="firstname"
        />
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 lastname-container mb-4"
        :class="{ 'is-invalid': $v.lastname.$error }"
      >
        <div>
          <label :for="'personal-input-last-name' + _uid"
            ><span>*</span> Apellido</label
          >
        </div>

        <input
          type="text"
          class="form-control"
          :id="'personal-input-last-name' + _uid"
          v-model="lastname"
        />
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 socialName-container mb-4"
        :class="{ 'is-invalid': $v.socialName.$error }"
      >
        <div>
          <label :for="'personal-input-social-name' + _uid"
            >Nombre de Pila</label
          >
          <span
            class="btn btn-sm p-0 align-middle ml-1"
            @click="showModalDiversityInput()"
            ><icon-help-circle-outline class="text-muted"
          /></span>
        </div>

        <input
          type="text"
          class="form-control"
          :id="'personal-input-social-name' + _uid"
          v-model="socialName"
        />
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 email-container mb-4"
        :class="{ 'is-invalid': $v.email.$error }"
      >
        <div>
          <label :for="'personal-input-email' + _uid"
            ><span>*</span> Correo electrónico</label
          >
        </div>

        <input
          type="email"
          class="form-control"
          :id="'personal-input-email' + _uid"
          v-model="email"
        />
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 phone-container mb-4"
        :class="{ 'is-invalid': $v.phone.$error }"
      >
        <div>
          <label :for="'personal-input-phone' + _uid"
            ><span>*</span> Teléfono celular</label
          >
        </div>

        <the-mask
          type="tel"
          class="form-control"
          :id="'personal-input-phone' + _uid"
          :mask="['#################']"
          v-model="phone"
        />
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 raceAndEthnicity-container mb-4"
        :class="{ 'is-invalid': $v.raceAndEthnicity.$error }"
      >
        <div>
          <label :for="'personal-input-raceAndEthnicity' + _uid"
            ><span>*</span>Raza/Etnicidad</label
          >
          <span
            class="btn btn-sm p-0 align-middle ml-1"
            @click="showModalDiversityInput()"
            ><icon-help-circle-outline class="text-muted"
          /></span>
        </div>

        <selectize
          :id="'personal-input-raceAndEthnicity' + _uid"
          :settings="raceAndEthnicitySettings"
          v-model="raceAndEthnicity"
        >
          <option
            :value="raceAndEthnicity.id"
            v-for="(raceAndEthnicity, index) in $store.state.domains
              .race_and_ethnicities"
            :key="index"
          >
            {{ raceAndEthnicity.id == "black" ? "Afrodescendiente" : "" }}
            {{ raceAndEthnicity.id == "indigenous" ? "Indígena" : "" }}
            {{ raceAndEthnicity.id == "asian" ? "Amarillo" : "" }}
            {{ raceAndEthnicity.id == "white" ? "Blanco" : "" }}
            {{ raceAndEthnicity.id == "other" ? "Otro" : "" }}
            {{ raceAndEthnicity.id == "no_reply" ? "No quiero contestar" : "" }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 gender-container mb-4"
        :class="{ 'is-invalid': $v.gender.$error }"
      >
        <div>
          <label :for="'personal-input-gender' + _uid"
            ><span>*</span> Tu identidad de género</label
          >
          <span
            class="btn btn-sm p-0 align-middle ml-1"
            @click="showModalDiversityInput()"
            ><icon-help-circle-outline class="text-muted"
          /></span>
        </div>

        <selectize
          :id="'personal-input-gender' + _uid"
          :settings="genderSettings"
          v-model="gender"
        >
          <option
            :value="gender.id"
            v-for="(gender, index) in $store.state.domains.genders"
            :key="index"
          >
            {{ gender.id == "male" ? "Hombre cisgénero" : "" }}
            {{ gender.id == "female" ? "Mujer cisgénero" : "" }}
            {{ gender.id == "trans_male" ? "Hombre transgénero" : "" }}
            {{ gender.id == "trans_female" ? "Mujer transgénero" : "" }}
            {{ gender.id == "intergender" ? "Intergénero" : "" }}
            {{ gender.id == "no_gender" ? "Agénero" : "" }}
            {{ gender.id == "transvestite" ? "Travesti" : "" }}
            {{ gender.id == "non_binary" ? "No binario" : "" }}
            {{ gender.id == "other" ? "Otro" : "" }}
            {{ gender.id == "no_reply" ? "No quiero contestar" : "" }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 sexualOrientation-container mb-4"
        :class="{ 'is-invalid': $v.sexualOrientation.$error }"
      >
        <div>
          <label :for="'personal-input-sexual-orientation' + _uid"
            ><span>*</span> Orientación sexual</label
          >
          <span
            class="btn btn-sm p-0 align-middle ml-1"
            @click="showModalDiversityInput()"
            ><icon-help-circle-outline class="text-muted"
          /></span>
        </div>

        <selectize
          :id="'personal-input-sexual-orientation' + _uid"
          :settings="sexualOrientationSettings"
          v-model="sexualOrientation"
        >
          <option
            :value="sexualOrientation.id"
            v-for="(sexualOrientation, index) in $store.state.domains
              .sexual_orientations"
            :key="index"
          >
            {{ sexualOrientation.id == "assexual" ? "Asexual" : "" }}
            {{ sexualOrientation.id == "bissexual" ? "Bisexual" : "" }}
            {{ sexualOrientation.id == "heterossexual" ? "Heterosexual" : "" }}
            {{ sexualOrientation.id == "homossexual" ? "Homosexual" : "" }}
            {{ sexualOrientation.id == "pansexual" ? "Pansexual" : "" }}
            {{ sexualOrientation.id == "other" ? "Otro" : "" }}
            {{
              sexualOrientation.id == "no_reply" ? "No quiero contestar" : ""
            }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 birthday-container mb-4"
        :class="{ 'is-invalid': $v.birthday.$error }"
      >
        <div>
          <label :for="'personal-input-birthday' + _uid"
            ><span>*</span> Fecha de nacimiento</label
          >
        </div>

        <the-mask
          type="tel"
          class="form-control"
          :id="'personal-input-birthday' + _uid"
          :mask="'##/##/####'"
          :masked="true"
          v-model="birthday"
        />
        <small class="form-text text-danger" v-if="birthdayMessage">{{
          birthdayMessage
        }}</small>
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 nationality-container mb-4"
        :class="{ 'is-invalid': $v.nationality.$error }"
      >
        <div>
          <label :for="'personal-input-nationality' + _uid"
            ><span>*</span> Nacionalidad</label
          >
        </div>

        <selectize
          :id="'personal-input-nationality' + _uid"
          :settings="nationalitySettings"
          v-model="nationality"
        >
          <option
            :value="country.name"
            v-for="(country, index) in $store.state.domains.countries"
            :key="index"
          >
            {{ country.id == '1' ? "Afganistán" : "" }}
            {{ country.id == '2' ? "Sudáfrica" : "" }}
            {{ country.id == '3' ? "Albania" : "" }}
            {{ country.id == '4' ? "Alemania" : "" }}
            {{ country.id == '5' ? "Andorra" : "" }}
            {{ country.id == '6' ? "Angola" : "" }}
            {{ country.id == '7' ? "Anguila" : "" }}
            {{ country.id == '8' ? "Antártida" : "" }}
            {{ country.id == '9' ? "Antigua y Barbuda" : "" }}
            {{ country.id == '10' ? "Antillas Holandesas" : "" }}
            {{ country.id == '11' ? "Arabia Saudita" : "" }}
            {{ country.id == '12' ? "Argelia" : "" }}
            {{ country.id == '13' ? "Argentina" : "" }}
            {{ country.id == '14' ? "Armenia" : "" }}
            {{ country.id == '15' ? "Aruba" : "" }}
            {{ country.id == '16' ? "Australia" : "" }}
            {{ country.id == '17' ? "Austria" : "" }}
            {{ country.id == '18' ? "Azerbaiyán" : "" }}
            {{ country.id == '19' ? "Bahamas" : "" }}
            {{ country.id == '20' ? "Bahréin" : "" }}
            {{ country.id == '21' ? "Bangladesh" : "" }}
            {{ country.id == '22' ? "Barbados" : "" }}
            {{ country.id == '23' ? "Bélgica" : "" }}
            {{ country.id == '24' ? "Belice" : "" }}
            {{ country.id == '25' ? "Benín" : "" }}
            {{ country.id == '26' ? "Bermudas" : "" }}
            {{ country.id == '27' ? "Bielorrusia" : "" }}
            {{ country.id == '28' ? "Bolivia" : "" }}
            {{ country.id == '29' ? "Bosnia y Herzegovina" : "" }}
            {{ country.id == '30' ? "Botsuana" : "" }}
            {{ country.id == '31' ? "Brasil" : "" }}
            {{ country.id == '32' ? "Brunéi" : "" }}
            {{ country.id == '33' ? "Bulgaria" : "" }}
            {{ country.id == '34' ? "Burkina Faso" : "" }}
            {{ country.id == '35' ? "Burundi" : "" }}
            {{ country.id == '36' ? "Bután" : "" }}
            {{ country.id == '37' ? "Cabo Verde" : "" }}
            {{ country.id == '38' ? "Camerún" : "" }}
            {{ country.id == '39' ? "Camboya" : "" }}
            {{ country.id == '40' ? "Canadá" : "" }}
            {{ country.id == '41' ? "Kazajistán" : "" }}
            {{ country.id == '42' ? "Chad" : "" }}
            {{ country.id == '43' ? "Chile" : "" }}
            {{ country.id == '44' ? "China" : "" }}
            {{ country.id == '45' ? "Chipre" : "" }}
            {{ country.id == '46' ? "Colombia" : "" }}
            {{ country.id == '47' ? "Comoras" : "" }}
            {{ country.id == '48' ? "Corea del Sur" : "" }}
            {{ country.id == '49' ? "Costa de Marfil" : "" }}
            {{ country.id == '50' ? "Costa Rica" : "" }}
            {{ country.id == '51' ? "Croacia" : "" }}
            {{ country.id == '52' ? "Cuba" : "" }}
            {{ country.id == '53' ? "Dinamarca" : "" }}
            {{ country.id == '54' ? "Djibouti" : "" }}
            {{ country.id == '55' ? "Dominica" : "" }}
            {{ country.id == '56' ? "Egipto" : "" }}
            {{ country.id == '57' ? "El Salvador" : "" }}
            {{ country.id == '58' ? "Emiratos Árabes Unidos" : "" }}
            {{ country.id == '59' ? "Ecuador" : "" }}
            {{ country.id == '60' ? "Eritrea" : "" }}
            {{ country.id == '61' ? "Eslovaquia" : "" }}
            {{ country.id == '62' ? "Eslovenia" : "" }}
            {{ country.id == '63' ? "España" : "" }}
            {{ country.id == '64' ? "Estados Federados de Micronesia" : "" }}
            {{ country.id == '65' ? "Estados Unidos de América" : "" }}
            {{ country.id == '66' ? "Estonia" : "" }}
            {{ country.id == '67' ? "Etiopía" : "" }}
            {{ country.id == '68' ? "Fiji" : "" }}
            {{ country.id == '69' ? "Filipinas" : "" }}
            {{ country.id == '70' ? "Finlandia" : "" }}
            {{ country.id == '71' ? "Francia" : "" }}
            {{ country.id == '72' ? "Gabón" : "" }}
            {{ country.id == '73' ? "Gambia" : "" }}
            {{ country.id == '74' ? "Ghana" : "" }}
            {{ country.id == '75' ? "Georgia" : "" }}
            {{ country.id == '76' ? "Gibraltar" : "" }}
            {{ country.id == '77' ? "Grecia" : "" }}
            {{ country.id == '78' ? "Granada" : "" }}
            {{ country.id == '79' ? "Groenlandia" : "" }}
            {{ country.id == '80' ? "Guadalupe" : "" }}
            {{ country.id == '81' ? "Guam" : "" }}
            {{ country.id == '82' ? "Guatemala" : "" }}
            {{ country.id == '83' ? "Guernsey" : "" }}
            {{ country.id == '84' ? "Guinea" : "" }}
            {{ country.id == '85' ? "Guinea Francesa" : "" }}
            {{ country.id == '87' ? "Guinea-Bissau" : "" }}
            {{ country.id == '88' ? "Guinea-Conakry" : "" }}
            {{ country.id == '86' ? "Guinea Ecuatorial" : "" }}
            {{ country.id == '89' ? "Haití" : "" }}
            {{ country.id == '90' ? "Honduras" : "" }}
            {{ country.id == '91' ? "Hong Kong" : "" }}
            {{ country.id == '92' ? "Hungría" : "" }}
            {{ country.id == '93' ? "Yemen" : "" }}
            {{ country.id == '94' ? "Isla Bouvet" : "" }}
            {{ country.id == '95' ? "Isla de Navidad" : "" }}
            {{ country.id == '96' ? "Isla de Man" : "" }}
            {{ country.id == '97' ? "Islas Heard y McDonald" : "" }}
            {{ country.id == '98' ? "Isla Norfolk" : "" }}
            {{ country.id == '99' ? "Islas Åland" : "" }}
            {{ country.id == '100' ? "Islas Caimán" : "" }}
            {{ country.id == '101' ? "Islas Cocos" : "" }}
            {{ country.id == '102' ? "Islas Cook" : "" }}
            {{ country.id == '103' ? "Islas Feroe" : "" }}
            {{ country.id == '104' ? "Islas Georgias del Sur y Sandwich del Sur" : "" }}
            {{ country.id == '105' ? "Islas Marshall" : "" }}
            {{ country.id == '106' ? "Islas Ultramarinas Menores de Estados Unidos" : "" }}
            {{ country.id == '107' ? "Islas Salomón" : "" }}
            {{ country.id == '108' ? "Islas Vírgenes Americanas" : "" }}
            {{ country.id == '109' ? "Islas Vírgenes Británicas" : "" }}
            {{ country.id == '110' ? "Islas Malvinas" : "" }}
            {{ country.id == '111' ? "India" : "" }}
            {{ country.id == '112' ? "Indonesia" : "" }}
            {{ country.id == '113' ? "Irán" : "" }}
            {{ country.id == '114' ? "Irak" : "" }}
            {{ country.id == '115' ? "Irlanda" : "" }}
            {{ country.id == '116' ? "Islandia" : "" }}
            {{ country.id == '117' ? "Israel" : "" }}
            {{ country.id == '118' ? "Italia" : "" }}
            {{ country.id == '119' ? "Jamaica" : "" }}
            {{ country.id == '120' ? "Japón" : "" }}
            {{ country.id == '121' ? "Jersey" : "" }}
            {{ country.id == '122' ? "Jordania" : "" }}
            {{ country.id == '123' ? "Kiribati" : "" }}
            {{ country.id == '124' ? "Kuwait" : "" }}
            {{ country.id == '125' ? "Laos" : "" }}
            {{ country.id == '126' ? "Lesoto" : "" }}
            {{ country.id == '127' ? "Letonia" : "" }}
            {{ country.id == '128' ? "Líbano" : "" }}
            {{ country.id == '129' ? "Liberia" : "" }}
            {{ country.id == '130' ? "Libia" : "" }}
            {{ country.id == '131' ? "Liechtenstein" : "" }}
            {{ country.id == '132' ? "Lituania" : "" }}
            {{ country.id == '133' ? "Luxemburgo" : "" }}
            {{ country.id == '134' ? "Macao" : "" }}
            {{ country.id == '135' ? "Madagascar" : "" }}
            {{ country.id == '136' ? "Malasia" : "" }}
            {{ country.id == '137' ? "Malaui" : "" }}
            {{ country.id == '138' ? "Maldivas" : "" }}
            {{ country.id == '139' ? "Mali" : "" }}
            {{ country.id == '140' ? "Malta" : "" }}
            {{ country.id == '141' ? "Islas Marianas del Norte" : "" }}
            {{ country.id == '142' ? "Marruecos" : "" }}
            {{ country.id == '143' ? "Martinica" : "" }}
            {{ country.id == '144' ? "Mauricio" : "" }}
            {{ country.id == '145' ? "Mauritania" : "" }}
            {{ country.id == '146' ? "Mayotte" : "" }}
            {{ country.id == '147' ? "México" : "" }}
            {{ country.id == '148' ? "Mozambique" : "" }}
            {{ country.id == '149' ? "Moldavia" : "" }}
            {{ country.id == '150' ? "Mónaco" : "" }}
            {{ country.id == '151' ? "Mongolia" : "" }}
            {{ country.id == '152' ? "Montenegro" : "" }}
            {{ country.id == '153' ? "Montserrat" : "" }}
            {{ country.id == '154' ? "Myanmar (antigua Birmania)" : "" }}
            {{ country.id == '155' ? "Namibia" : "" }}
            {{ country.id == '156' ? "Nauru" : "" }}
            {{ country.id == '157' ? "Nepal" : "" }}
            {{ country.id == '158' ? "Nicaragua" : "" }}
            {{ country.id == '159' ? "Níger" : "" }}
            {{ country.id == '160' ? "Nigeria" : "" }}
            {{ country.id == '161' ? "Niue" : "" }}
            {{ country.id == '162' ? "Noruega" : "" }}
            {{ country.id == '163' ? "Nueva Caledonia" : "" }}
            {{ country.id == '164' ? "Nueva Zelanda (Aotearoa)" : "" }}
            {{ country.id == '165' ? "Omán" : "" }}
            {{ country.id == '166' ? "Países Bajos (Holanda)" : "" }}
            {{ country.id == '167' ? "Palau" : "" }}
            {{ country.id == '168' ? "Palestina" : "" }}
            {{ country.id == '169' ? "Panamá" : "" }}
            {{ country.id == '170' ? "Papúa-Nueva Guinea" : "" }}
            {{ country.id == '171' ? "Pakistán" : "" }}
            {{ country.id == '172' ? "Paraguay" : "" }}
            {{ country.id == '173' ? "Perú" : "" }}
            {{ country.id == '174' ? "Pitcairn" : "" }}
            {{ country.id == '175' ? "Polinesia Francesa" : "" }}
            {{ country.id == '176' ? "Polonia" : "" }}
            {{ country.id == '177' ? "Puerto Rico" : "" }}
            {{ country.id == '178' ? "Portugal" : "" }}
            {{ country.id == '179' ? "Catar" : "" }}
            {{ country.id == '180' ? "Kenia" : "" }}
            {{ country.id == '181' ? "Kirguistán" : "" }}
            {{ country.id == '182' ? "Reino Unido de Gran Bretaña e Irlanda del Norte" : "" }}
            {{ country.id == '183' ? "República Centroafricana" : "" }}
            {{ country.id == '184' ? "República Checa" : "" }}
            {{ country.id == '185' ? "República de Macedonia" : "" }}
            {{ country.id == '186' ? "República Democrática de (Corea del Norte) Corea" : "" }}
            {{ country.id == '187' ? "República Democrática del (antiguo Zaire) Congo" : "" }}
            {{ country.id == '188' ? "República del Congo" : "" }}
            {{ country.id == '189' ? "República Dominicana" : "" }}
            {{ country.id == '190' ? "Reunión" : "" }}
            {{ country.id == '191' ? "Rumanía" : "" }}
            {{ country.id == '192' ? "Ruanda" : "" }}
            {{ country.id == '193' ? "Rusia" : "" }}
            {{ country.id == '194' ? "Sahara Occidental" : "" }}
            {{ country.id == '195' ? "San Pedro y Miquelón" : "" }}
            {{ country.id == '196' ? "Samoa Americana" : "" }}
            {{ country.id == '197' ? "Samoa (Samoa Occidental)" : "" }}
            {{ country.id == '198' ? "San Marino" : "" }}
            {{ country.id == '199' ? "Santa Elena" : "" }}
            {{ country.id == '200' ? "Santa Lucía" : "" }}
            {{ country.id == '201' ? "São Cristóvão e Névis (San Cristóbal y Nieves)" : "" }}
            {{ country.id == '202' ? "São Tomé e Príncipe" : "" }}
            {{ country.id == '203' ? "São Vicente e Granadinas" : "" }}
            {{ country.id == '204' ? "Senegal" : "" }}
            {{ country.id == '205' ? "Sierra Leona" : "" }}
            {{ country.id == '206' ? "Serbia" : "" }}
            {{ country.id == '207' ? "Seychelles" : "" }}
            {{ country.id == '208' ? "Singapur" : "" }}
            {{ country.id == '209' ? "Siria" : "" }}
            {{ country.id == '210' ? "Somalia" : "" }}
            {{ country.id == '211' ? "Sri Lanka" : "" }}
            {{ country.id == '212' ? "Suazilandia" : "" }}
            {{ country.id == '213' ? "Sudán" : "" }}
            {{ country.id == '214' ? "Suecia" : "" }}
            {{ country.id == '215' ? "Suiza" : "" }}
            {{ country.id == '216' ? "Surinam" : "" }}
            {{ country.id == '217' ? "Svalbard y Jan Mayen" : "" }}
            {{ country.id == '218' ? "Tailandia" : "" }}
            {{ country.id == '219' ? "Taiwán" : "" }}
            {{ country.id == '220' ? "Tayikistán" : "" }}
            {{ country.id == '221' ? "Tanzania" : "" }}
            {{ country.id == '222' ? "Tierras Australes y Antárticas Francesas (TAAF)" : "" }}
            {{ country.id == '223' ? "Territorio Británico del Océano Índico" : "" }}
            {{ country.id == '224' ? "Timor Oriental" : "" }}
            {{ country.id == '225' ? "Togo" : "" }}
            {{ country.id == '226' ? "Tonga" : "" }}
            {{ country.id == '227' ? "Tokelau" : "" }}
            {{ country.id == '228' ? "Trinidad y Tobago" : "" }}
            {{ country.id == '229' ? "Túnez" : "" }}
            {{ country.id == '230' ? "Islas Turcas y Caicos" : "" }}
            {{ country.id == '231' ? "Turkmenistán" : "" }}
            {{ country.id == '232' ? "Turquía" : "" }}
            {{ country.id == '233' ? "Tuvalu" : "" }}
            {{ country.id == '234' ? "Ucrania" : "" }}
            {{ country.id == '235' ? "Uganda" : "" }}
            {{ country.id == '236' ? "Uruguay" : "" }}
            {{ country.id == '237' ? "Uzbekistán" : "" }}
            {{ country.id == '238' ? "Vanuatu" : "" }}
            {{ country.id == '239' ? "Vaticano" : "" }}
            {{ country.id == '240' ? "Venezuela" : "" }}
            {{ country.id == '241' ? "Vietnam" : "" }}
            {{ country.id == '242' ? "Wallis y Futuna" : "" }}
            {{ country.id == '243' ? "Zambia" : "" }}
            {{ country.id == '244' ? "Zimbabue" : ""}}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 document-container mb-4"
        :class="{ 'is-invalid': $v.cpf.$error || $v.passport.$error }"
      >
        <div>
          <label :for="'personal-input-document' + _uid"><span>*</span>
            {{ isForeign ? (nationality == 'México' ? 'CURP' : 'Documento (Cédula de Identidad Personal, Cédula de Ciudadanía...)') : 'CPF' }}
          </label>
        </div>

        <the-mask
          v-if="!isForeign"
          type="tel"
          class="form-control"
          :id="'personal-input-document' + _uid"
          mask="###.###.###-##"
          v-model="cpf"
          :readOnly="cpfReadOnly"
        />
        <input
          v-else
          type="text"
          class="form-control"
          :id="'personal-input-document' + _uid"
          v-model="passport"
          :readOnly="passportReadOnly"
        />
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 personalIncome-container mb-4"
        :class="{ 'is-invalid': $v.personalIncome.$error }"
      >
        <div>
          <label :for="'personal-input-personalIncome' + _uid"
            ><span>*</span> Tu ingreso mensual</label
          >
          <span
            class="btn btn-sm p-0 align-middle ml-1"
            @click="showModalDiversityInput()"
            ><icon-help-circle-outline class="text-muted"
          /></span>
        </div>

        <selectize
          :id="'personal-input-personalIncome' + _uid"
          :settings="personalIncomeSettings"
          v-model="personalIncome"
        >
          <option
            :value="personalIncome.id"
            v-for="(personalIncome, index) in $store.state.domains
              .personal_incomes"
            :key="index"
          >
            {{ personalIncome.id == "0" ? "Sin ingresos" : "" }}
            {{ personalIncome.id == "0-2" ? "Hasta 2 salarios mínimos" : "" }}
            {{ personalIncome.id == "2-4" ? "De 2 a 4 salarios mínimos" : "" }}
            {{
              personalIncome.id == "4-10" ? "De 4 a 10 salarios mínimos" : ""
            }}
            {{
              personalIncome.id == "10-20" ? "De 10 a 20 salarios mínimos" : ""
            }}
            {{
              personalIncome.id == "20+"
                ? "Por encima de 20 salarios mínimos"
                : ""
            }}
            {{ personalIncome.id == "no_reply" ? "No quiero contestar" : "" }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 familyIncome-container mb-4"
        :class="{ 'is-invalid': $v.familyIncome.$error }"
      >
        <div>
          <label :for="'personal-input-familyIncome' + _uid"
            ><span>*</span> Tu ingreso familiar</label
          >
          <span
            class="btn btn-sm p-0 align-middle ml-1"
            @click="showModalDiversityInput()"
            ><icon-help-circle-outline class="text-muted"
          /></span>
        </div>

        <selectize
          :id="'personal-input-familyIncome' + _uid"
          :settings="familyIncomeSettings"
          v-model="familyIncome"
        >
          <option
            :value="familyIncome.id"
            v-for="(familyIncome, index) in $store.state.domains.family_incomes"
            :key="index"
          >
            {{ familyIncome.id == "0" ? "Sin ingresos" : "" }}
            {{ familyIncome.id == "0-2" ? "Hasta 2 salarios mínimos" : "" }}
            {{ familyIncome.id == "2-4" ? "De 2 a 4 salarios mínimos" : "" }}
            {{ familyIncome.id == "4-10" ? "De 4 a 10 salarios mínimos" : "" }}
            {{
              familyIncome.id == "10-20" ? "De 10 a 20 salarios mínimos" : ""
            }}
            {{
              familyIncome.id == "20+"
                ? "Por encima de 20 salarios mínimos"
                : ""
            }}
            {{ familyIncome.id == "no_reply" ? "No quiero contestar" : "" }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 marital-status-container mb-4"
      >
        <div>
          <label :for="'personal-input-marital-status' + _uid"
            >Estado Civil</label
          >
        </div>

        <selectize
          :id="'personal-input-marital-status' + _uid"
          :settings="maritalStatusSettings"
          v-model="maritalStatus"
        >
          <option
            :value="status.id"
            v-for="(status, index) in $store.state.domains.maritalStatus.filter((m) => m.id != 'separate')"
            :key="index"
          >
            {{ status.id == "single" ? "Soltero" : "" }}
            {{ status.id == "married" ? "Casado" : "" }}
            {{ status.id == "separate" ? "Apartado" : "" }}
            {{ status.id == "divorced" ? "Divorciado" : "" }}
            {{ status.id == "widower" ? "Viudo" : "" }}
          </option>
        </selectize>
      </div>

      <!-- <div v-if=""> -->
      <FormQuestions
        class="col-12"
        v-if="$route.name == 'ficha' && showFormQuestions == true"
      />
      <!-- </div> -->

      <div class="form-group col-12 divider-container">
        <hr />
      </div>

      <div class="form-group col-12 d-flex flex-wrap mb-3">
        <div>
          <label class="mb-0 mr-3">¿Tienes alguna discapacidad?</label>
        </div>

        <div class="">
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              :id="'personal-input-disability-true' + _uid"
              class="custom-control-input"
              v-model="has_disability"
              :value="true"
            />
            <label
              class="custom-control-label"
              :for="'personal-input-disability-true' + _uid"
              >Sí</label
            >
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              :id="'personal-input-disability-false' + _uid"
              class="custom-control-input"
              v-model="has_disability"
              :value="false"
            />
            <label
              class="custom-control-label"
              :for="'personal-input-disability-false' + _uid"
              >No</label
            >
          </div>
        </div>
      </div>

      <div class="form-group col-12 mb-4" v-show="has_disability == true">
        <div class="row mx-0 d-flex align-items-center justify-content-between">
          <div
            class="col-12 col-sm-5 col-md-3 mb-2 custom-control custom-checkbox custom-control-inline"
            :class="{
              'is-invalid': $v.disabilities.$error && has_disability == true,
            }"
            v-for="(deficiency, index) in $store.state.domains.disabilities"
            :key="index"
          >
            <input
              type="checkbox"
              class="custom-control-input"
              :id="'personal-input-disability-' + _uid + deficiency.id"
              v-model="disabilities"
              :value="deficiency.id"
            />
            <label
              class="custom-control-label"
              :for="'personal-input-disability-' + _uid + deficiency.id"
            >
              {{ deficiency.id == "11" ? "Auditivo (habla libras)" : "" }}
              {{ deficiency.id == "12" ? "Auditivo (oralizado)" : "" }}
              {{ deficiency.id == "1" ? "Auditivo total" : "" }}
              {{ deficiency.id == "5" ? "De habla" : "" }}
              {{ deficiency.id == "4" ? "Físico" : "" }}
              {{ deficiency.id == "3" ? "Intelectual suave" : "" }}
              {{ deficiency.id == "6" ? "Otros" : "" }}
              {{ deficiency.id == "8" ? "Psicosocial" : "" }}
              {{ deficiency.id == "7" ? "Trastorno del espectro autista" : "" }}
              {{ deficiency.id == "9" ? "Visual - Baja Visión" : "" }}
              {{ deficiency.id == "2" ? "Visual - Ciego total" : "" }}
              {{ deficiency.id == "10" ? "Visual - Monocular" : "" }}
              {{ deficiency.id == "14" ? "Auditivo" : "" }}
              {{ deficiency.id == "13" ? "Auditivo Parcial" : "" }}
              {{ deficiency.id == "15" ? "Visual" : "" }}
            </label>
          </div>
        </div>
        <!-- <MedicalReport v-on:isLoading="(isL) => (isLoading = isL)" /> -->
      </div>

      <div class="form-group col-12 d-flex flex-wrap" v-if="has_disability">
        <div>
          <label class="mb-0 mr-3"
            >¿Tiene alguna necesidad de ayuda durante el proceso de
            selección?</label
          >
        </div>

        <div class="">
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              :id="'personal-input-need-help-selection-process-true' + _uid"
              class="custom-control-input"
              v-model="need_help_selection_process"
              :value="true"
            />
            <label
              class="custom-control-label"
              :for="'personal-input-need-help-selection-process-true' + _uid"
              >Sí</label
            >
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              :id="'personal-input-need-help-selection-process-false' + _uid"
              class="custom-control-input"
              v-model="need_help_selection_process"
              :value="false"
            />
            <label
              class="custom-control-label"
              :for="'personal-input-need-help-selection-process-false' + _uid"
              >No</label
            >
          </div>
        </div>
      </div>

      <div class="form-group col-12 mb-4" v-if="need_help_selection_process">
        <textarea
          type="text"
          class="form-control"
          v-model="description_help_selection_process"
          placeholder="Escriba aquí cualquier apoyo especial que su característica como una persona con discapacidad demande durante la participación en el reclutamiento (ej.: descripción de texto en audios, aumento de tamaño de texto…)"
          :id="'personal-input-description_help_selection_process' + _uid"
          rows="5"
          maxlength="100"
        ></textarea>
        <span
          :class="
            description_help_selection_process.length == '100' ? 'limiter' : ''
          "
        >
          <small> {{ caharactersLeft }} </small>
        </span>
      </div>

      <div class="form-group col-12 divider-container">
        <hr />
      </div>

      <div
        class="form-group col-12 col-md-6 mb-4"
        :class="{ 'is-invalid': $v.zipcode.$error }"
      >
        <div>
          <label :for="'personal-input-zip-code' + _uid"
            ><span>*</span> Código postal</label
          >
        </div>

        <the-mask
          type="tel"
          class="form-control"
          :id="'personal-input-zip-code' + _uid"
          :mask="'#####-###'"
          v-model="zipcode"
          @keyup.native="getAddress()"
        />
      </div>

      <div
        class="form-group col-12 col-md-6 mb-4"
        :class="{ 'is-invalid': $v.street.$error }"
      >
        <div>
          <label :for="'personal-input-street' + _uid"
            ><span>*</span> Calle</label
          >
        </div>
        <input
          type="text"
          class="form-control"
          :id="'personal-input-street' + _uid"
          v-model="street"
        />
      </div>

      <div
        class="form-group col-12 col-md-4 mb-4"
        :class="{ 'is-invalid': $v.number.$error }"
      >
        <div>
          <label :for="'personal-input-number' + _uid"
            ><span>*</span> Número</label
          >
        </div>
        <input
          type="text"
          class="form-control"
          :id="'personal-input-number' + _uid"
          v-model="number"
        />
      </div>

      <div class="form-group col-12 col-md-4 mb-4">
        <div>
          <label :for="'personal-input-complement' + _uid">Información complementaria</label>
        </div>
        <input
          type="text"
          class="form-control"
          :id="'personal-input-complement' + _uid"
          v-model="complement"
        />
      </div>

      <div
        class="form-group col-12 col-md-4 mb-4"
      >
        <div>
          <label :for="'personal-input-neighborhood' + _uid"
            >Barrio</label
          >
        </div>

        <input
          type="text"
          class="form-control"
          :id="'personal-input-neighborhood' + _uid"
          v-model="neighborhood"
        />
      </div>

      <div class="form-group col-12 divider-container">
        <hr />
      </div>

      <div class="form-group col-12" mb-4>
        <div>
          <label :for="'personal-input-resume' + _uid"
            >¿Hay algo más que creas que es importante contar sobre vos?</label
          >
        </div>
        <textarea
          type="text"
          class="form-control"
          placeholder="Escribe aquí"
          :id="'personal-input-resume' + _uid"
          rows="5"
          v-model="whatDoYouLove"
        ></textarea>
      </div>
    </div>

    <p class="small text-right font-italic">
      Los campos con * son obligatorios.
    </p>

    <div class="d-flex align-items-center mt-4" v-if="hasButtons">
      <button type="reset" class="btn btn-light mr-auto" @click="reset()">
        Cancelar
      </button>
      <button type="submit" class="btn btn-blue-ml">Ahorrar</button>
    </div>
  </form>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, requiredIf } from 'vuelidate/lib/validators';
import IconHelpCircleOutline from 'vue-material-design-icons/HelpCircleOutline.vue';
import InputAvatar from '../Media/InputAvatar.vue';
import LoaderContent from '../Loader/LoaderContent.vue';
import FormQuestions from '../Questions/FormQuestions.vue';
// import MedicalReport from "@/components/subscription/PersonalData/MedicalReport.vue";
export default {
  name: 'FormPersonalData',
  data() {
    return {
      firstname: '',
      lastname: '',
      socialName: '',
      email: '',
      nationality: '',
      document_label: 'CPF',
      cpf: '',
      cpfReadOnly: false,
      passport: '',
      passportReadOnly: false,
      gender: '',
      sexualOrientation: '',
      raceAndEthnicity: '',
      pronoun: '',
      personalIncome: '',
      familyIncome: '',
      maritalStatus: '',
      phone: '',
      birthday: '',
      has_disability: false,
      disabilities: [],
      need_help_selection_process: false,
      description_help_selection_process: '',
      medical_report: '',
      zipcode: '',
      street: '',
      number: '',
      complement: '',
      neighborhood: '',
      state: '',
      city: '',
      whatDoYouLove: '',
      birthdayMessage: null,
      nationalitySettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      genderSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      sexualOrientationSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      raceAndEthnicitySettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      pronounSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      personalIncomeSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      maritalStatusSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      familyIncomeSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      stateSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
        onChange: (value) => {
          this.state = value;
          this.$store.dispatch(
            'graphql_queries/query',
            `domains(state: "${
              this.$store.state.domains.states.find((st) => st.id == value)
                .abbr
            }") {
                cities {id, name, abbr},
            }`,
          );
        },
      },
      citySettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      isLoading: false,
      source: 'chatbot',
    };
  },

  props: {
    hasButtons: {
      type: Boolean,
      default: false,
    },

    storeByEventBus: {
      type: Boolean,
      default: false,
    },
    showFormQuestions: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    caharactersLeft() {
      const char = this.description_help_selection_process.length;
      const limit = 100;
      return `${limit - char} / ${limit}`;
    },

    isForeign() {
      return !(
        this.nationality
        && this.nationality.toLowerCase().indexOf('brasil') != -1
      );
    },
  },

  watch: {
    has_disability(newValue) {
      if (!newValue || newValue == false) {
        this.disabilities = [];
      }
    },
  },

  mixins: [validationMixin],

  validations: {
    firstname: { required },
    lastname: {},
    socialName: {},
    email: { required },
    nationality: { required },
    cpf: {
      required: requiredIf(function (value) {
        return !this.isForeign;
      }),
    },
    passport: {
      required: requiredIf(function (value) {
        return this.isForeign;
      }),
    },
    phone: {
      required,
      isValid: (value, _this) => {
        if (!value) return false;
        const phone = value.replace(/[^0-9]/g, '');
        return !phone.match(/^(\d)\1+$/g);
      },
    },
    birthday: {
      required,
      isDate: (value, _this) => {
        const year = value.split('/')[2];
        const current_year = new Date().getFullYear(); // ano atual
        const age = current_year - year;

        if (age < 10) {
          _this.birthdayMessage = 'Data inválida';
          return false;
        }

        if (age > 100) {
          _this.birthdayMessage = 'Data inválida';
          return false;
        }

        if (
          _this.$moment(`${value.split('/').reverse().join('-')}`).isValid()
          == false
        ) {
          _this.birthdayMessage = 'Data inválida';
          return false;
        }

        _this.birthdayMessage = null;
        return true;
      },
    },
    gender: { required },
    sexualOrientation: {
      required: requiredIf((value) => {
        const getClass = document.querySelector('.sexualOrientation-container');
        const style = getComputedStyle(getClass);
        return style.display !== 'none';
      }),
     },
    raceAndEthnicity: {
      required: requiredIf((value) => {
        const getClass = document.querySelector('.raceAndEthnicity-container');
        const style = getComputedStyle(getClass);
        return style.display !== 'none';
      }),
     },
    pronoun: {
      required: requiredIf((value) => {
        const getClass = document.querySelector('.pronoun-container');
        const style = getComputedStyle(getClass);
        return style.display !== 'none';
      }),
     },
    personalIncome: {
      required: requiredIf((value) => {
        const getClass = document.querySelector('.personalIncome-container');
        const style = getComputedStyle(getClass);
        return style.display !== 'none';
      }),
    },
    familyIncome: {
      required: requiredIf((value) => {
        const getClass = document.querySelector('.familyIncome-container');
        const style = getComputedStyle(getClass);
        return style.display !== 'none';
      }),
    },
    zipcode: { required },
    street: { required },
    number: { required },
    // neighborhood: { required },
    // state: { required },
    // city: { required },
    has_disability: { required },
    disabilities: {
      required: requiredIf(function (value) {
        return this.has_disability == true;
      }),
    },
    description_help_selection_process: {},
  },

  components: {
    InputAvatar,
    LoaderContent,
    FormQuestions,
    // MedicalReport,
    IconHelpCircleOutline,
  },

  mounted() {
    setTimeout(() => this.removeAutoFillSelectize(), 500);
    this.getPersonalData();
  },

  destroyed() {
    this.$EventBus.$off('editingPersonalData');
    this.$EventBus.$off('storePersonalDataForm');
    this.$store.commit('PERSONAL_DATA_FORM', {});
  },

  methods: {
    showModalDiversityInput() {
      this.$EventBus.$emit('showModalDiversityInputs', 'modal-personal-data');
    },

    getPersonalData() {
      this.isLoading = true;
      let requestDomainReturn = '';

      if (this.$store.state.domains.countries.length == 0) {
        requestDomainReturn += 'countries { id, name },';
      }
      if (this.$store.state.domains.maritalStatus.length == 0) {
        requestDomainReturn += 'maritalStatus {id, description},';
      }
      if (this.$store.state.domains.states.length == 0) {
        requestDomainReturn += 'states { id, name, abbr },';
      }
      if (this.$store.state.domains.education_levels.length == 0) {
        requestDomainReturn += 'educationLevels {id, description},';
      }
      if (this.$store.state.domains.education_periods.length == 0) {
        requestDomainReturn += 'educationPeriods {id, description},';
      }
      if (this.$store.state.domains.education_status.length == 0) {
        requestDomainReturn += 'educationStatus {id, description},';
      }
      if (this.$store.state.domains.companies.length == 0) {
        requestDomainReturn += 'companies {id, name},';
      }
      if (
        this.$store.state.domains.professional_experience_levels.length == 0
      ) {
        requestDomainReturn += 'professionalExperienceLevels {id, name}';
      }
      if (this.$store.state.domains.cause_experience_areas.length == 0) {
        requestDomainReturn += 'causeExperienceAreas {id, description},';
      }
      if (this.$store.state.domains.language_proficiencies.length == 0) {
        requestDomainReturn += 'languageProficiencies {id, description},';
      }

      requestDomainReturn += 'professionalExperienceAreas {id, name},';
      requestDomainReturn += 'genders { id, description },';
      requestDomainReturn += 'raceAndEthnicities { id, description },';
      requestDomainReturn += 'pronouns { id, description },';
      requestDomainReturn += 'personalIncomes { id, description },';
      requestDomainReturn += 'familyIncomes { id, description },';
      requestDomainReturn += 'sexualOrientations {id, description},';
      requestDomainReturn += 'disabilities { id, name },';

      if (requestDomainReturn.length > 0) {
        requestDomainReturn = `domains {
          ${requestDomainReturn}
        },`;
      }

      this.$store
        .dispatch(
          'graphql_queries/query',
          `${requestDomainReturn} user( id: "${this.$store.state.user.profile.id}" ){
          avatar,
          medicalReports {
            id,
            name,
            file
          },
          profile{
            firstname,
            lastname,
            socialName,
            email,
            nationality,
            cpf,
            passport,
            gender,
            maritalStatus,
            phone,
            birthday,
            raceAndEthnicity,
            pronoun,
            sexualOrientation,
            personalIncome,
            familyIncome,
            descriptionHelpSelectionProcess,
            needHelpSelectionProcess,

            location {
              zipcode,
              street,
              number,
              complement,
              neighborhood,
              stateId,
              city
            },

            hasDisability,

            disabilities {
              disabilityId,
              name
            },

            educations {
              id,
              institutionName,
              level,
              courseName,
              startDate,
              endDate,
              stateId
            },

            professionalExperiences {
              id,
              role,
              responsabilities,
              company,
              startYear,
              endYear
            },

            languageProficiencies {
              id,
              language,
              proficiency
            },

            additionalQuestions {
              id,
              question,
              answer,
              slug
            },

            preSubscription {
              details
            }
          }
        }`,
        )
        .then(async () => {
          setTimeout(() => this.setPersonalDataFields(), 1000);
        });
    },

    setPersonalDataFields() {
      this.isLoading = true;
      const { profile } = this.$store.state.user;

      this.firstname = profile.firstname;
      this.lastname = profile.lastname;
      this.socialName = profile.socialName;
      this.email = profile.email;
      this.nationality = profile.nationality
        ? profile.nationality
        : profile.passport
          ? ''
          : '';
      this.cpf = profile.cpf;
      this.cpfReadOnly = this.cpf != null && this.cpf.length > 0;
      this.passport = profile.passport;
      this.passportReadOnly = this.passport != null && this.passport.length > 0;
      this.gender = profile.gender;
      this.raceAndEthnicity = profile.raceAndEthnicity;
      this.pronoun = profile.pronoun;
      this.familyIncome = profile.familyIncome;
      this.personalIncome = profile.personalIncome;
      this.sexualOrientation = profile.sexualOrientation;
      this.maritalStatus = profile.maritalStatus;
      this.phone = profile.phone;
      this.birthday = this.$moment(profile.birthday).format('DD/MM/YYYY');
      this.disabilities = profile.disabilities.map(
        (disability) => disability.disabilityId,
      );
      this.has_disability = profile.hasDisability || this.disabilities.length > 0;
      this.whatDoYouLove = profile.whatDoYouLove;
      this.need_help_selection_process = profile.needHelpSelectionProcess || false;
      this.description_help_selection_process = profile.descriptionHelpSelectionProcess || '';
      if (profile.location) {
        this.zipcode = profile.location.zipcode;
        this.street = profile.location.street;
        this.number = profile.location.number;
        this.complement = profile.location.complement;
        this.neighborhood = profile.location.neighborhood;
        this.state = profile.location.stateId;
        // if (this.state) {
        //   this.$store
        //     .dispatch(
        //       "graphql_queries/query",
        //       `domains(state: "${
        //         this.$store.state.domains.states.find(
        //           (st) => st.id == this.state
        //         ).abbr
        //       }") {
        //           cities {id, name, abbr},
        //         }`
        //     )
        //     .then(() => {
        //       this.city = this.$helpers.cleanStringToCompare(
        //         profile.location.city
        //       );
        //     });
        // }
      }

      this.$EventBus.$on('storePersonalDataForm', this.storeForm);
      this.isLoading = false;
    },

    reset(closeModal = true) {
      this.isLoading = false;
      this.$v.$reset();
      if (closeModal) this.$emit('closeModal');
      Object.assign(this.$data, this.$options.data.call(this));
      this.setPersonalDataFields();
    },

    getAddress() {
      if (this.zipcode != null && this.zipcode.replace(/\D/g, '').length != 8) {
        return false;
      }

      this.$store
        .dispatch('location/addressByZipCode', this.zipcode)
        .then((address) => {
          this.street = address.logradouro;
          this.number = '';
          this.complement = '';
          this.neighborhood = address.bairro;
          this.state = this.$store.state.domains.states.find(
            (st) => st.abbr.toUpperCase() == address.uf.toUpperCase(),
          ).id;
          this.$store
            .dispatch(
              'graphql_queries/query',
              `domains(state: "${
                this.$store.state.domains.states.find(
                  (st) => st.id == this.state,
                ).abbr
              }") {
              cities {id, name, abbr},
            }
          `,
            )
            .then(() => {
              this.city = this.$helpers.cleanStringToCompare(
                address.localidade,
              );
            });
        });
    },

    // Salva o formulário no banco de dados e retorna o perfil atualizado
    saveForm() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const data = this.$data;

      this.$store.dispatch('user/personalDataUpdate', data).then((response) => {
        if (response.error) {
          this.$swal(
            'Uoops',
            'Hubo un error al guardar tu información',
            'error',
          );
        } else {
          this.$store
            .dispatch(
              'graphql_queries/query',
              `user( id: "${this.$store.state.user.profile.id}" ){
                profile{
                  firstname,
                  lastname,
                  socialName,
                  email,
                  nationality,
                  cpf,
                  passport,
                  gender,
                  sexualOrientation,
                  raceAndEthnicity,
                  pronoun,
                  personalIncome,
                  maritalStatus,
                  phone,
                  birthday,
                  whatDoYouLove,
                  familyIncome,
                  descriptionHelpSelectionProcess,
                  needHelpSelectionProcess,
                  location {
                    zipcode,
                    street,
                    number,
                    complement,
                    neighborhood,
                    stateId,
                    city
                  },
                  disabilities {
                    disabilityId,
                    name
                  },
                }
              }`,
            )
            .then(() => {
              this.$swal(
                'Pronto!',
                'Datos personales guardados con éxito',
                'success',
              );
              this.reset();
            });
        }
      });
    },

    // Salva o formulário localmente para poder salvar na API em algum momento futuro do fluxo
    storeForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$store.commit('PERSONAL_DATA_FORM', {
          error: true,
        });

        setTimeout(() => {
          Array.from(this.$el.querySelectorAll('.is-invalid')).some((field) => {
            field.querySelector('input').focus();
            return field;
          });
        }, 100);
      } else {
        this.$store.commit('PERSONAL_DATA_FORM', {
          data: this.$data,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  font-size: 14px;
}
.form-group {
  margin-bottom: 0.5rem;
  &:not(.divider-container) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  hr {
    margin-bottom: 0.4rem;
    margin-top: 0.4rem;
  }
}
.limiter {
  color: red;
}
</style>
